// extracted by css-extract-rspack-plugin
export default {"root":"ERP_root__LCcd5"};